import React from "react";
import {connect} from "react-redux";
import {StyleSheet, Text, TouchableOpacity, View} from "react-native";
import AvatarIcon from "../Header/AvatarIcon";


class ContactListItem extends React.Component{
    constructor(props) {
        super(props);
    }

    render() {
        const styles = StyleSheet.create({
           container:{
               flexDirection:"row",
               alignItems:"center",
               margin:13,

           },
            icon :{
               width:40,
               height:40,
                borderRadius:15,
                marginRight:10
            },
            text:{
               color : this.props.theme.colors.tertiary.black1.value,
                fontSize:15,
                fontFamily: this.props.theme.fonts.text,
                fontWeight:"600"
            }
        });
        return (
            <TouchableOpacity onPress={()=>{this.props.addCommentMention(this.props.contact,this.props.search)}} style={styles.container}>
                <AvatarIcon style={styles.icon} icon={this.props.contact.img} />
                <Text style={styles.text}>{this.props.contact.firstname} {this.props.contact.lastname}</Text>
            </TouchableOpacity>
        );
    }
}

const mapStateToProps = (state) => {
    return {isDark: state.changeTheme.isDark,theme: state.changeTheme.theme, auth : state.AuthReducer};
}

export default connect(mapStateToProps)(ContactListItem);
